import styled from "styled-components";

export const EditContainer = styled.section`
  background-color: transparent;
  margin: 48px 0;
  width: 100%;
  overflow-y: auto;
  padding-right: 10px;
  @media (max-width: 1024px) {
    /* height: unset; */
    padding: 0 16px;
    margin: 80px auto 200px auto;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-height: auto;
  overflow-x: hidden;
  direction: rtl;
  border-radius: 16px;
  background-color: var(--bg-white);
  padding: 40px 60px;
  box-shadow: 2px 4px 10px rgba(108, 136, 170, 0.25);
  border: 1px solid var(--bg-gray);
  margin-bottom: 24px;
  & input {
    color: var(--text-500);
    @media (max-width: 360px) {
      font-size: 12px;
    }
  }
  & input::placeholder {
    font-size: 16px;
    font-weight: 500;
    @media (max-width: 360px) {
      font-size: 12px;
      font-weight: 700;
    }
  }

  &:nth-of-type(2) {
    margin-bottom: 0px;
    & input {
      color: var(--text-500);
      font-size: 14px;
      font-weight: 700;
      @media (max-width: 360px) {
        font-size: 12px;
      }
    }
    & input::placeholder {
      font-size: 14px;
      font-weight: 700;
      @media (max-width: 360px) {
        font-size: 12px;
      }
    }
  }
  & .title {
    margin: 0 0 32px 90px;
    @media (max-width: 1024px) {
      margin: 0 0 16px 0;
    }
    & h2 {
      font-size: 18px;
      font-weight: 700;
      color: var(--text-500);
    }
  }
  @media (max-width: 1024px) {
    flex-direction: column;
    box-shadow: unset;
    background-color: unset;
    padding: 0;
    border: none;
    border-radius: 0;
    padding: 0;
    margin-bottom: 32px;
    max-height: auto;
    overflow-x: visible;
    &:nth-of-type(1) {
      & .title h2 {
        display: none;
      }
    }
  }
`;

export const TitleContainer = styled.section`
  display: flex;
  flex-direction: column;
  padding: 0 30px;
  position: relative;
  width: max-content;
  @media (max-width: 1024px) {
    padding: 0;
    margin-bottom: 40px;
    margin-top: 20px;
  }
  & > div {
    cursor: pointer;
    input {
      opacity: 0;
      /* width: 15%; */
      height: 30px;
      position: absolute;
      top: 58%;
      left: 56%;
      cursor: pointer;
    }
  }
  & picture {
    padding: 0;
    position: relative;
    position: absolute;
    top: 202px;
    right: 27%;
    cursor: pointer;
  }
  @media (max-width: 360px) {
    padding-right: 20px;
    & picture {
      top: 20px;
      right: 35%;
    }
  }
  h2 {
    font-size: 18px;
    font-weight: 700;
    color: #27548c;
    padding: 0;
    width: max-content;
    @media (max-width: 360px) {
      padding-right: 0;
      width: 100%;
      color: #27548c;
    }
  }
`;

export const ImageContainer = styled.div`
  width: 152px;
  height: 152px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    border-radius: 50%;
    border: 4px solid #ff7d7d;
    @media (max-width: 360px) {
      border: 4px solid #bfc9f3;
      /* object-fit: fill; */
    }
  }
  @media (max-width: 360px) {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -30px);
    width: 118px;
    height: 118px;
    bottom: 10px;
  }
`;

export const FormWrapper = styled.section`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  height: fit-content;
  /* max-width: 1008px; */
  margin: 0 auto;
  /* margin: 32px 90px 32px 0; */
  form {
    label {
      display: none;
      color: #2d3134;
      margin: 0;
    }
  }
  @media (max-width: 1024px) {
    /* width: 360px; */
    background: #ffffff;
    border: 1px solid #e9ebf8;
    box-shadow: 2px 4px 10px rgba(108, 136, 170, 0.25);
    border-radius: 16px;
    margin: 0 auto;
    padding: 32px 16px 16px 16px;
    width: 100%;
    margin: 0 auto;
    justify-content: center;
    form {
      & > div:first-child {
        & > div {
          width: 100%;
          & > div:last-child {
            width: 100%;
          }
        }
      }
    }
    form label {
      display: block;
      margin-bottom: 4px;
      font-size: 14px;
      font-weight: 500;
      color: var(--text-500);
    }
  }
  @media (max-width: 360px) {
    form label {
      font-size: 12px;
      font-weight: 400;
    }
  }
`;

export const ChangePasswordContainer = styled.div`
  h2 {
    margin-right: -210px;
    @media (max-width: 360px) {
      margin-right: 0;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 32px;
  @media (max-width: 768px) {
    justify-content: center;
    width: 100%;
    align-items: center;
    flex-direction: row-reverse;
  }
  & button {
    height: 40px;
    width: 140px;
    font-size: 16px;
    font-weight: 700;
    margin-left: 16px;
    color: var(--primary-600);
    @media (max-width: 768px) {
      margin-right: 14px;
      margin-left: 0;
      width: 100%;
      font-size: 14px;
    }
    &:last-child {
      margin-left: 0;
      margin-right: 0;
      color: var(--bg-disable);
    }
  }
`;

export const UploadContainer = styled.div``;

export const FormRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  & > div {
    height: 76px;
    margin-left: 8px;
    @media (max-width: 1024px) {
      margin-bottom: 24px;
      height: auto;
      margin-left: 0;
    }
    & input::placeholder {
      color: var(--text-500);
    }
  }
  & > div:last-child {
    margin-left: 0;
  }
`;

export const ExitContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 32px;
  & button {
    width: 100%;
    outline: 0;
    border: none;
    padding: 10px 0;
    height: 48px;
    font-size: 16px;
    cursor: pointer;
    font-weight: 700;
    color: var(--bg-white);
    background-color: var(--error-300);
    border: 2px solid var(--error-300);
    border-radius: 8px;
  }
`;
